// =============================================================
// Game Configuration
// =============================================================

// --- Rendering mode ---
// true = InstancedMesh (optimized, fewer draw calls)
// false = SceneObject (legacy, per-object rendering)
export const USE_INSTANCED_RENDERING = true;

// --- Physics objects types (have collision) ---
// const PHYSICS_TYPES = ["palm", "palm_tree", "stone", "cactus", "crystal", "banana_tree", "isl"];
export const PHYSICS_TYPES = [ "palm_tree", "stone", "cactus", "crystal", "banana_tree", "isl"];

// --- Outline settings ---
export const OUTLINE_ENABLED = true;
export const OUTLINE_THICKNESS = 1.5;
export const OUTLINE_COLOR = [0.0, 0.0, 0.0];
export const OUTLINE_OPACITY = 0.5;

// --- Character/NPC outline settings ---
export const CHARACTER_OUTLINE_THICKNESS = 1.2;
export const CHARACTER_OUTLINE_OPACITY = 0.5;

// --- Island (menu globe) outline settings ---
export const ISLAND_OUTLINE_THICKNESS = 0.5;
export const ISLAND_OUTLINE_OPACITY = 0.5;

// --- Planet sphere outline settings ---
export const PLANET_OUTLINE_THICKNESS = 0.8;
export const PLANET_OUTLINE_OPACITY = 0.5;

// --- Initially unlocked maps ---
export const INITIAL_UNLOCKED_MAPS = ["1", "27"];

// --- Ground intersection line ---
export const GROUND_LINE_ENABLED = true;
export const GROUND_LINE_THICKNESS = 1.5;
export const GROUND_LINE_OPACITY = 0.5;
